import { css } from 'aphrodite';
import * as React from 'react';
import { IAIAgentTemplateAttachment } from '../../../../../extViewmodels/sdk/models/AI';
import { useAIAgentTemplateAttachmentDownloadMutation } from '../../../../../queries/AIAgentTemplate';
import { Button } from '../../../../../web/components-v2/Button';
import { styles } from './styles';

interface AIAgentTemplateAttachmentItemProps {
	attachment: IAIAgentTemplateAttachment;
	templateId?: string;
	onRemove: () => void;
}

export function AIAgentTemplateAttachmentItem({
	attachment,
	templateId,
	onRemove,
}: AIAgentTemplateAttachmentItemProps) {
	const [isDownloading, setIsDownloading] = React.useState(false);

	const downloadMutation = useAIAgentTemplateAttachmentDownloadMutation({
		onSuccess: data => {
			if (data.url) {
				window.open(data.url, '_blank');
			}
			setIsDownloading(false);
		},
		onError: () => {
			setIsDownloading(false);
		},
	});

	const handleDownload = () => {
		if (!templateId) return;
		setIsDownloading(true);
		downloadMutation.mutate({ templateId, attachmentId: attachment.fileAttachment.id });
	};

	const formatFileSize = (bytes: number): string => {
		if (bytes === 0) return '0 Bytes';
		const k = 1024;
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
	};

	const fileAttachment = attachment.fileAttachment;
	const canDownload = !!templateId;

	return (
		<div className={css(styles.attachmentItem)}>
			<div className={css(styles.attachmentInfo)}>
				{canDownload ? (
					<Button variant='link' styles={[styles.attachmentNameLink]} onClick={handleDownload} disabled={isDownloading}>
						{isDownloading ? 'Opening...' : fileAttachment.fileName}
					</Button>
				) : (
					<div className={css(styles.attachmentName)}>{fileAttachment.fileName}</div>
				)}
				<div className={css(styles.attachmentSize)}>{formatFileSize(fileAttachment.fileSize)}</div>
			</div>
			<Button variant='secondary' onClick={onRemove}>
				Remove
			</Button>
		</div>
	);
}
